import { object, string, date } from 'yup';

export const CompactExpenseSchema = object().shape({
  name: string().required(),
  category: object().required(),
  location: object().required(),
  date: date().required(),
});
